import {
  type ConfigOf,
  Element,
  InstallSpec,
  ItemComponent,
} from "@p0security/shared/install/types";
import { pathSegmentIdValidator } from "@p0security/shared/install/validators";

export const GrafanaCloudComponents = InstallSpec({
  scim: ItemComponent({
    type: "string",
    label: "Team management",
    maturity: "preview",
    // The domain is part of the SCIM API URL
    validator: pathSegmentIdValidator,
    schema: {
      scimToken: Element({
        type: "encrypted",
        label: "SCIM service-account token",
        description:
          "Enter a token for a Grafana service account with 'User administration:Write' and 'Teams:Write' roles",
      }),
      stackId: Element({
        type: "string",
        label: "Grafana stack ID",
        description:
          "Enter the 'Stack ID' displayed on your Grafana Cloud SCIM authentication plugin configuration page",
      }),
    },
  }),
});

export type GrafanaCloudComponents = typeof GrafanaCloudComponents;
export type GrafanaCloudIntegration = ConfigOf<GrafanaCloudComponents>;
